module.exports = __webpack_public_path__ + "img/lessonpre_collection_normal.f8771327.svg";